define(["require", "exports", "@material-ui/core"], function (require, exports, core_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.useStyles = void 0;
    // eslint-disable-next-line import/prefer-default-export
    exports.useStyles = core_1.makeStyles((theme) => ({
        paper: {
            marginTop: theme.spacing(8),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        avatar: {
            margin: theme.spacing(1),
            backgroundColor: theme.palette.secondary.main,
        },
        form: {
            width: '100%',
            marginTop: theme.spacing(1),
        },
        submit: {
            margin: theme.spacing(3, 0, 2),
        },
        error: {
            color: theme.palette.error.main,
        },
        success: {
            color: theme.palette.success.main,
        },
    }));
});
//# sourceMappingURL=styles.js.map